import { render, staticRenderFns } from "./AccessTableItem.vue?vue&type=template&id=eca4819e&scoped=true"
import script from "./AccessTableItem.vue?vue&type=script&lang=js"
export * from "./AccessTableItem.vue?vue&type=script&lang=js"
import style0 from "./AccessTableItem.vue?vue&type=style&index=0&id=eca4819e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca4819e",
  null
  
)

export default component.exports